'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './density.routes';

export class DensityComponent {
  /*@ngInject*/
  constructor($state, $scope, $rootScope, fetch, lookup, userService, $stateParams) {
    const vm = this;
    this.$scope = $scope;
    this.$state = $state;
    this.fetch = fetch;
    this.lookup = lookup;
    this.userService = userService;
    this.$stateParams = $stateParams;
    this.$scope.loadingData = true;


    $scope.activityType = 'Density';
    $scope.showTierOverride = false;

    $scope.tier4Corridors = [
      "Bayshore Caltrain",
      "Orinda BART",
      "Lafayette BART",
      "Belmont Caltrain",
      "San Carlos Caltrain"
    ];

    /**
     * todo move these values to a service
     */
    $scope.dataDictionary = [
      {
        "ID": 1,
        "Field": "zn_recid",
        "Field Alias": "Zoning Code ID"
      },
      {
        "ID": 2,
        "Field": "zn_county",
        "Field Alias": "Zoning County"
      },
      {
        "ID": 3,
        "Field": "zn_jurisdiction",
        "Field Alias": "Zoning Jurisdiction"
      },
      {
        "ID": 4,
        "Field": "zn_code",
        "Field Alias": "Zoning Code"
      },
      {
        "ID": 5,
        "Field": "zn_description",
        "Field Alias": "Zoning Description"
      },
      {
        "ID": 6,
        "Field": "zn_regional_code",
        "Field Alias": "Zoning Regional Code"
      },
      {
        "ID": 7,
        "Field": "zn_regional_description",
        "Field Alias": "Zoning Regional Description"
      },
      {
        "ID": 8,
        "Field": "allows_comm_office",
        "Field Alias": "Allows Office"
      },
      {
        "ID": 9,
        "Field": "allows_residential",
        "Field Alias": "Allows Residential"
      },
      {
        "ID": 10,
        "Field": "toc_min_dua",
        "Field Alias": "Minimum Density"
      },
      {
        "ID": 11,
        "Field": "toc_max_dua",
        "Field Alias": "Maximum Density"
      },
      {
        "ID": 12,
        "Field": "toc_max_far",
        "Field Alias": "Maximum FAR"
      },
      {
        "ID": 13,
        "Field": "toc_min_far",
        "Field Alias": "Minimum FAR"
      }
    ];

    $scope.thresholds = [
      {
        'tier': '1',
        'threshold': {
          toc_min_dua: 100,
          toc_max_dua: 150,
          toc_min_far: 4,
          toc_max_far: 8
        }
      },
      {
        'tier': '2',
        'threshold': {
          toc_min_dua: 75,
          toc_max_dua: 100,
          toc_min_far: 3,
          toc_max_far: 6
        }
      },
      {
        'tier': '3',
        'threshold': {
          toc_min_dua: 50,
          toc_max_dua: 75,
          toc_min_far: 2,
          toc_max_far: 4
        }
      },
      {
        'tier': '4',
        'threshold': {
          toc_min_dua: 25,
          toc_max_dua: 35,
          toc_min_far: 1,
          toc_max_far: 3
        }
      }
    ]

    $scope.note = '<strong>Note: Measurement units</strong><br/> DUA = Dwelling Units per Acre. <br/>FAR = Floor Area Ratio<br>';

    /**
      * @function getStationbyID
      * @description Gets the station data by ID
      * @param {string} stationId The station ID
      */
    $scope.getStationbyID = function (station) {
      $scope.loadingData = true;
      if (station) {
        lookup.setCurrentStation(station);
      }
      fetch.getItem(`api/data/density/averages/${$scope.currentJurisdiction}`, $scope.currentSelectedStationId)
        .then(response => {
          $scope.currentStation = response.data[0];

          // Call the overrideTierForSpecificCorridors function
          $scope.overrideTierForSpecificCorridors($scope.currentStation);

          if ($scope.currentStation && $scope.currentStation.service_tier) {
            var tier = $scope.currentStation.service_tier.toString();
            $scope.complianceThresholds = (_.filter($scope.thresholds, { 'tier': tier }))[0].threshold;
          }

          //Get Submission Policy List for Messages sidebar
          // Using optional chaining and nullish coalescing
          vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);

          console.log("submission summary: ", $scope.submissionSummary);

          $scope.loadingData = false;
          console.log($scope.loadingData)
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
     
      $scope.getActivity();
    }.bind(this);

    /**
      * @function getStationAreaList
      * @description Gets the list of station areas for a given jurisdiction
      * @param {string} jurisdiction The jurisdiction
      */
    $scope.getStationAreaList = function (jurisdiction) {
      // Check for the sta_recid parameter from $stateParams
      const staRecId = $stateParams.sta_recid;

      fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
        .then(response => {
          $scope.stationAreas = response.data;

          if (staRecId) {
            $scope.currentSelectedStationId = staRecId; // Set currentSelectedStationId from sta_recid
          } else if (lookup.getCurrentStation()) {
            $scope.currentSelectedStationId = lookup.getCurrentStation(); // Fallback to lookup service
          } else {
            $scope.currentSelectedStationId = $scope.stationAreas[0].sta_recid;
          }

          lookup.setCurrentStation($scope.currentSelectedStationId);

          // Call getStationbyID() after setting the currentSelectedStationId
          $scope.getStationbyID();
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        });
    };


    /**
    * @function getsubmissionActivity
    * @description Gets the density activity data
    */
    $scope.getActivity = function () {
      var activityData = [];
      fetch.getAllItems(`api/data/submission/activity/${$scope.currentSelectedStationId}/${$scope.activityType}`)
        .then(response => {
          $scope.submissionActivity = response.data;

        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    /**
    * @function overrideTierForSpecificCorridors
    * @description Overrides the service_tier for specific corridors
    * @param {object} currentStation The current station object
    * @returns {number} The overridden service_tier or the original service_tier
    */

    $scope.overrideTierForSpecificCorridors = function (currentStation) {
      console.log(currentStation);
      if (currentStation) {
        if ($scope.tier4Corridors.includes($scope.currentStation.station_name)) {
          $scope.showTierOverride = true;
          // Override service_tier to 4
          currentStation.service_tier = 4;

          // Apply Tier 4 thresholds
          $scope.complianceThresholds = _.filter($scope.thresholds, { 'tier': '4' })[0].threshold;
          $scope.complianceThresholdsTier3 = _.filter($scope.thresholds, { 'tier': '3' })[0].threshold;
          // Update Compliance thresholds for commercial density to be the same as tier 3 
          $scope.complianceThresholds.toc_min_far = $scope.complianceThresholdsTier3.toc_min_far;
          $scope.complianceThresholds.toc_max_far = $scope.complianceThresholdsTier3.toc_max_far;
        }
        else {
          $scope.showTierOverride = false;
        }
      }
    }.bind(this);
  };

  /**
      * @function $onInit
      * @description Initializes the component
      */
  $onInit() {

    this.userService.getCurrentUser()
      .then(response => {

        this.$scope.currentUser = response.data;
        this.userService.setCurrentUser(response.data);
        this.getJurisdictionList();


      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          this.$state.go('login');
        }
      })


  }

  /**
    * @function getJurisdictionList
    * @description Gets the list of jurisdictions
    */
  getJurisdictionList() {
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
      .then(response => {
        this.$scope.loading = false;
        this.$scope.jurisdictions = response.data;

        // Check if user role is Administrator
        if (this.$scope.currentUser.role === 'Administrator') {
          console.log("admin");
          // Check for the jurisdiction parameter in the URL
          const jurisdictionParam = this.$stateParams.jurisdiction;
          console.log(this.$stateParams);
          if (jurisdictionParam) {
            this.$scope.currentJurisdiction = jurisdictionParam;
          } else if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        } else {
          if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        }
        console.log(this.$scope.currentJurisdiction);
        this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
        this.$scope.getStationAreaList(this.$scope.currentJurisdiction);

      })
      .catch(err => {
        console.log(err);
      });
  }

  getStationAreaSubmissionSummary(stationId) {
    console.log('Getting summary for station:', stationId);
    this.lookup.setCurrentStation(stationId);

    if (this.$scope.stationAreas.length > 0) {
      this.$scope.stationAreas.forEach(element => {
        element.active = element.sta_recid === stationId;
        if (element.active) {
          this.$scope.stationAreaTitle = element.station_name;
        }
      });

      return this.fetch.getItem(
        `api/data/policies/${this.$scope.currentJurisdiction}`,
        stationId
      )
        .then(response => {
          console.log('Policy data:', response);
           this.$scope.submissionSummary = response.data;
          console.log("submission summary: ", this.$scope.submissionSummary);
          this.lookup.setSubmissionPolicies(this.$scope.submissionSummary);

          // Process density submissions
          this.$scope.densitySubmissions = _.filter(response.data,
            { submission_policy_type: "Density" });
          this.$scope.densitySubmitted = _.filter(this.$scope.densitySubmissions,
            { submitted: true });
          this.$scope.densityCompliant = _.filter(this.$scope.densitySubmissions,
            { status: 'Compliant' });

          // Process housing policy submissions
          this.$scope.housingPolicySubmissions = _.filter(response.data,
            { submission_policy_type: "Housing Production Policy" });
          this.$scope.housingPolicySubmissions = _.union(
            this.$scope.housingPolicySubmissions,
            _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" })
          );
          this.$scope.housingPolicySubmitted = _.filter(
            this.$scope.housingPolicySubmissions,
            { submitted: true }
          );
          this.$scope.housingPolicyCompliant = _.filter(
            this.$scope.housingPolicySubmissions,
            { status: 'Compliant' }
          );

          // Process parking submissions
          this.$scope.parkingSubmissions = _.filter(response.data,
            { submission_policy_type: "Parking" });
          this.$scope.parkingSubmitted = _.filter(this.$scope.parkingSubmissions,
            { submitted: true });
          this.$scope.parkingCompliant = _.filter(this.$scope.parkingSubmissions,
            { status: 'Compliant' });

          // Process station access submissions
          this.$scope.stationAccessSubmissions = _.filter(response.data,
            { submission_policy_type: "Station Area Access" });
          this.$scope.stationAccessSubmitted = _.filter(
            this.$scope.stationAccessSubmissions,
            { submitted: true }
          );
          this.$scope.stationAccessCompliant = _.filter(
            this.$scope.stationAccessSubmissions,
            { status: 'Compliant' }
          );
        });

      this.$scope.loading = false;
    } else {
      this.$scope.stationAreaTitle = '--';
      return Promise.resolve();
    }
  }




}

export default angular.module('appApp.density', [uiRouter])
  .config(routes)
  .component('density', {
    template: require('./density.html'),
    controller: DensityComponent,
    controllerAs: 'densityCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/density/density.component.js